/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthAcceptInvitationRequest, AuthAcceptInvitationResponse } from '../types/AuthAcceptInvitation'

/**
 * POST /auth/accept-invitation
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::acceptInvitation
 */
export async function authAcceptInvitation(
	data: AuthAcceptInvitationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthAcceptInvitationResponse>> {
	return axiosInstance.post('/auth/accept-invitation', data, config)
}
